// extracted by mini-css-extract-plugin
export var actions = "_4t-0";
export var actionsContainer = "_4t-7";
export var border = "_4t-1";
export var childFullHeight = "_4t-f";
export var collapse = "_4t-2";
export var content = "_4t-a";
export var contentChild = "_4t-e";
export var fullscreen = "_4t-c";
export var hasLeftRadius = "_4t-k";
export var headerContainer = "_4t-3";
export var headerRow = "_4t-5";
export var hidePadding = "_4t-b";
export var navCollapsedGap = "_4t-l";
export var noScrollX = "_4t-m";
export var noScrollY = "_4t-n";
export var noTopPadding = "_4t-i";
export var optOutTopPadding = "_4t-d";
export var pageMain = "_4t-j";
export var pageOuter = "_4t-g";
export var pagePadding = "_4t-8";
export var pageScroll = "_4t-9";
export var profile = "_4t-o";
export var profileContainer = "_4t-p";
export var profileImage = "_4t-q";
export var profileMain = "_4t-r";
export var profileSubtitle = "_4t-t";
export var profileTitle = "_4t-s";
export var showLeftPadding = "_4t-h";
export var tabsPortalSlot = "_4t-6";
export var tabsWrapper = "_4t-4";
export var title = "_4t-u";